module.exports = {"610502001":"人民街道","610502002":"杜桥街道","610502003":"解放街道","610502004":"向阳街道","610502005":"站南街道","610502006":"双王街道","610502007":"良田街道","610502008":"崇业路街道","610502009":"辛市街道","610502010":"龙背街道","610502011":"阳曲街道","610502012":"信义街道","610502013":"白杨街道","610502100":"桥南镇","610502101":"阳郭镇","610502102":"故市镇","610502103":"下邽镇","610502104":"三张镇","610502105":"交斜镇","610502107":"崇宁镇","610502108":"孝义镇","610502109":"吝店镇","610502111":"官底镇","610502112":"官路镇","610502113":"丰原镇","610502114":"阎村镇","610502116":"官道镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610502.json
// module id = 2821
// module chunks = 0